import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import DisplayField from '../fields/displayfield/DisplayField'
import { startDateFormatString } from '../../js/constants'

const TerminalMaintenanceDisplay = props => {
  return (
    <div className="content-wrapper">
      <div className="content">
        <div className="detail-view-section">
          <h1>Information</h1>
          <div className="single-view">
            <DisplayField title={'Message'} value={props.selectedMaintenance.message} />
          </div>
        </div>

        <div className="detail-view-section">
          <h1>Timeframe</h1>
          <div className="double-view">
            <DisplayField
              title={'Start time'}
              value={moment(props.selectedMaintenance.startTime).format(startDateFormatString)}
            />
            <DisplayField
              title={'End time'}
              value={moment(props.selectedMaintenance.endTime).format(startDateFormatString)}
            />
          </div>
        </div>

        <div className="detail-view-section">
          <h1>Bollards</h1>
          <div className="double-view">
            <DisplayField title={'Start bollard'} value={props.selectedMaintenance.bollardStart} />
            <DisplayField title={'End bollard'} value={props.selectedMaintenance.bollardEnd} />
          </div>
        </div>
      </div>
    </div>
  )
}

TerminalMaintenanceDisplay.propTypes = {
  selectedMaintenance: PropTypes.object.isRequired
}

export default TerminalMaintenanceDisplay
